import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loadingIndex: -1,
}

const slice = createSlice({
  initialState,
  name: 'ultrahighHome',
  reducers: {
    setLoadingIndex: (state, action) => {
      state.loadingIndex = action.payload;
    },
    clearLoadingIndex: (state) => {
      state.loadingIndex = -1;
    },
  }
})

export const {
  setLoadingIndex, clearLoadingIndex,
} = slice.actions;

export default slice;